import {createReducer} from '@reduxjs/toolkit'
import _ from 'lodash'
import {TOGGLE_EVENT_DETAILS_OLD, closeAllEvents, toggleEventDetails} from '../actions/events'
import {MembersPageState} from '../types/state'

const defaultState: MembersPageState['expandedEvents'] = []

export const expandedEvents = createReducer(defaultState, builder => {
  builder
    .addCase(toggleEventDetails.fulfilled, (state, action) => {
      const eventId = action.meta.arg.event.event.id
      if (state.includes(eventId)) {
        return _.without(state, eventId)
      } else {
        return [...state, eventId]
      }
    })
    .addCase(closeAllEvents, () => defaultState)
    .addMatcher(
      action => action.type === TOGGLE_EVENT_DETAILS_OLD,
      (state, action) => {
        const eventId = action.payload
        if (state.includes(eventId)) {
          return _.without(state, eventId)
        } else {
          return [...state, eventId]
        }
      },
    )
})
